/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SELECTED_SUBTOPIC_CHANGED } from '../data/actionTypes';
import { selectIsFetchingTopics } from '../data/loading/slice';
import { MAX_SUBTOPICS, TOPIC_CLUSTERS_DASHBOARD_LINK, TopicTypes } from '../data/topicEditor/constants';
import { selectSelectedSubtopicId } from '../data/topicEditor/slice';
import { selectSubtopicDropdownOptions } from '../data/topics/slice';
import { fetchTopics } from '../data/topics/thunks';
import { useDispatch, useSelector } from '../store';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SubtopicDropdown = ({
  selectedClusterId,
  onOpenCreateTopicDialog
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTopics({
      clusterId: selectedClusterId
    }));
  }, [dispatch, selectedClusterId]);
  const isFetchingTopics = useSelector(selectIsFetchingTopics);
  const selectedSubtopicId = useSelector(selectSelectedSubtopicId);
  const options = useSelector(selectSubtopicDropdownOptions);
  const canCreateSubtopic = options.length < MAX_SUBTOPICS;
  const handleSubtopicChange = event => {
    const {
      value
    } = event.target;
    dispatch({
      type: SELECTED_SUBTOPIC_CHANGED,
      payload: {
        selectedSubtopicId: value
      }
    });
  };
  if (isFetchingTopics) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 100
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.label"
    }),
    "data-test-id": "topic-editor-subtopic-dropdown",
    children: /*#__PURE__*/_jsx(Select, {
      minimumSearchCount: 0,
      options: options,
      value: selectedSubtopicId,
      onChange: handleSubtopicChange,
      dropdownFooter: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.footer.maxTopicLimitTooltip"
            }),
            disabled: canCreateSubtopic,
            children: /*#__PURE__*/_jsx(Button, {
              disabled: !canCreateSubtopic,
              use: "link",
              onClick: () => {
                onOpenCreateTopicDialog(TopicTypes.SUBTOPIC);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.footer.createTopic"
              })
            })
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlock: "200",
          as: "p",
          children: /*#__PURE__*/_jsx(Button, {
            use: "link",
            external: true,
            href: TOPIC_CLUSTERS_DASHBOARD_LINK,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.footer.editTopics"
            })
          })
        })]
      }),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.placeholder"
      }),
      searchable: true
    })
  });
};